import { useState, useEffect } from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import ModalColorsSystemConfigurations from '../../components/ModalColorsSystemConfigurations/ModalColorsSystemConfigurations';
import { setSystemColors, getSystemColors } from '../../../../services/helpers';
import { MODE } from '../../../../interaces/mode.interface';
import toast from 'react-hot-toast';
import {
  TOAST_SUCCESS_IDS,
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
} from '../../../../interaces/toast.ids.interface';
import ModalSmtpSystemConfigurations from '../../components/ModalSmtpSystemConfigurations/ModalSmtpSystemConfigurations';
import { DataTable } from '../../../../components/DataTable/DataTable';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import { colorSystemConfigurationsApi } from '../../api/colorSystemConfigurations.api';
import ModalRenapoSystemConfigurations from '../../components/ModalRenapoSystemConfigurations/ModalRenapoSystemConfigurations';
import { useColorsSystemConfigurations } from '../../hooks/useColorsSystemConfigurations';
import { useSmtpSystemConfigurations } from '../../hooks/useSmtpSystemConfigurations';
import {
  TABS_SYSTEM_CONFIGURATIONS,
  ENUM_TABS_OPTIONS,
} from '../../../../interaces/system-configuration.interface';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { useAuth } from '../../../../context/AuthContext';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import { updateDataWhenDelete } from '../../../../services/helpers';
import styles from "../../styles/styles.module.css"
function SystemConfigurations() {
  const {
    entities,
    setEntities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
  } = useColorsSystemConfigurations();
  const {
    entities: configurationSmtp,
    setEntities: setEntitiesSmtp,
    searchValue: searchValueSmtp,
    setSearchValue: setSearchValueSmtp,
    fetchSearch: fetchSearchSmtp,
    loading: loadingSmtp,
    onClear: onClearSmtp,
    dataPagination: dataPaginationSmtp,
    setPageData: setPageDataSmtp,
    pageData: pageDataSmtp,
  } = useSmtpSystemConfigurations();
  const { hasPrivilege } = useAuth();

  const [model, setModel] = useState(null);
  const [modelSmtp, setModelSmtp] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [openModalSmtp, setOpenModalSmtp] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [mode, setMode] = useState(MODE.CREATE);
  const [modeSmtp, setModeSmtp] = useState(MODE.CREATE);

  const [currentPrimaryColor, setCurrentPrimaryColor] = useState();
  const [currentSecondaryColor, setCurrentSecondaryColor] = useState();
  const [activeTab, setActiveTab] = useState(
    hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_READ)
      ? ENUM_TABS_OPTIONS.COLORS
      : hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_READ)
        ? ENUM_TABS_OPTIONS.SMTP
        : ENUM_TABS_OPTIONS.RENAPO
  );

  const handleSaved = () => {
    setRefreshKey((k) => k + 1);
  };
  useEffect(() => {
    if (activeTab == ENUM_TABS_OPTIONS.COLORS) {
      fetchSearch();
    }
    if (activeTab == ENUM_TABS_OPTIONS.SMTP) {
      fetchSearchSmtp();
    }
  }, [activeTab]);

  useEffect(() => {
    const p = getSystemColors().primaryColor;
    const s = getSystemColors().secondaryColor;
    setCurrentPrimaryColor(p);
    setCurrentSecondaryColor(s);
  }, [getSystemColors().primaryColor || getSystemColors().secondaryColor]);

  const onCloseOpenModal = () => {
    setOpenModal(false);
    setSystemColors(currentPrimaryColor, currentSecondaryColor);
  };
  //Para la tabla
  const [openModalConfirmation, setOPenModalConfirmation] = useState(false);
  const handleDelete = async () => {
    try {
      await colorSystemConfigurationsApi.remove(model.id);
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY, {
        id: TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY,
      });
      updateDataWhenDelete(setEntities, model.id);
      setOPenModalConfirmation(false);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD, {
        id: TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD,
      });
    } finally {
      setOPenModalConfirmation(false);
    }
  };
  const handleEdit = (model) => {
    setModel(model);
    setMode(MODE.UPDATE);
    setOpenModal(true);
  };
  const handleEditSmtp = (model) => {
    setModelSmtp(model);
    setOpenModalSmtp(true);
    setModeSmtp(MODE.UPDATE);
  };
  const updateStatus = async (entity, value) => {
    try {
      const response = await colorSystemConfigurationsApi.update(entity.id, { status: value });

      if (response) {
        setSystemColors(response.primaryColor, response.secondaryColor);
        setEntities((prev) =>
          prev.map((configuration) => {
            if (configuration.id === response.id) {
              return response;
            }
            if (configuration.status == true) {
              return {
                ...configuration,
                status: false,
              };
            } else {
              return configuration;
            }
          })
        );
      }
    } catch (error) {
      toast.error(error?.message || error?.error || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };

  const [enableSwitch, setEnableSwitch] = useState(false);

  const columns = [
    {
      accessorKey: 'nameTheme',
      header: 'NOMBRE DEL TEMA',
    },
    {
      accessorKey: 'primaryColor',
      header: 'COLOR PRIMARIO',
      cell: ({ row }) => {
        const primaryColor = row.original.primaryColor;
        return (
          <div className={styles.systemConfigurationMainDivColor}>
            <div className={styles.divColor} style={{ backgroundColor: primaryColor }} />
          </div>
        );
      },
    },
    {
      accessorKey: 'secondaryColor',
      header: 'COLOR SECUNDARIO',
      cell: ({ row }) => {
        const secondaryColor = row.original.secondaryColor;

        return (
          <div className={styles.systemConfigurationMainDivColor}>
            <div className={styles.divColor} style={{ backgroundColor: secondaryColor }} />
          </div>
        );
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'Acciones',
            cell: ({ row }) => {
              const entity = row.original;

              return (
                <ActionsTable
                  handleEdit={() => handleEdit(entity)}
                  handleDelete={() => {
                    setOPenModalConfirmation(true);
                    setModel(entity);
                  }}
                  tienePermisoEditar={hasPrivilege(
                    ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_UPDATE
                  )}
                  tienePermisoEliminar={hasPrivilege(
                    ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_DELETE
                  )}
                  canSwitch={hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_UPDATE)}
                  canDelete={
                    entity.type !== 'default' && entity.type !== 'veda' && entity.status === false
                  }
                  canEdit={entity.type !== 'default' && entity.type !== 'veda'}
                  enabled={entity.status}
                  setEnabled={setEnableSwitch}
                  onChangeSwitch={(value) => updateStatus(entity, value)}
                />
              );
            },
          },
        ]
      : []),
  ];
  //COLUMNS SMTP
  const columnsSmtp = [
    {
      accessorKey: 'sender',
      header: 'REMITENTE',
    },
    {
      accessorKey: 'typeSecurity',
      header: 'TIPO',
    },
    {
      accessorKey: 'serverSmtp',
      header: 'SERVIDOR',
    },
    {
      accessorKey: 'port',
      header: 'PUERTO',
    },
    {
      accessorKey: 'senderEmail',
      header: 'EMAIL',
    },
    {
      accessorKey: 'userSmtp',
      header: 'USUARIO',
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_UPDATE)
      ? [
          {
            id: 'acciones',
            header: 'Acciones',
            cell: ({ row }) => {
              const entity = row.original;
              return (
                <ActionsTable
                  handleEdit={() => handleEditSmtp(entity)}
                  tienePermisoEditar={hasPrivilege(
                    ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_UPDATE
                  )}
                  canDelete={false}
                />
              );
            },
          },
        ]
      : []),
  ];
  //
  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Administración de Configuraciones del sistema.</p>
          </div>
        </div>

        <div className="tabs-bar">
          {TABS_SYSTEM_CONFIGURATIONS.map(
            (tab) =>
              hasPrivilege(tab.permission) && (
                <button
                  key={tab.enum}
                  type="button"
                  onClick={() => setActiveTab(tab.enum)}
                  className={`tab-item ${activeTab === tab.enum ? 'tab-item-active' : ''}`}
                >
                  {tab.icon} {tab.id}
                </button>
              )
          )}
        </div>

        {activeTab == ENUM_TABS_OPTIONS.COLORS && (
          <DataTable
            columns={columns}
            data={entities}
            searchPlaceholder="Buscar configuración ..."
            pageSize={4}
            loading={loading}
            emptyMessage="No hay registros"
            onRowClick={(data) => {}}
            showSearch={true}
            showPagination={true}
            onSearch={() => fetchSearch()}
            searchValue={searchValue}
            showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_CREATE)}
            setOpenModal={setOpenModal}
            setMode={setMode}
            setModel={setModel}

            setSearchValue={setSearchValue}
            onClear={() => onClear()}

            dataPagination={dataPagination}
            setPageData={setPageData}
            pageData={pageData}
          />
        )}

        {activeTab == ENUM_TABS_OPTIONS.SMTP && (
          <DataTable
            columns={columnsSmtp}
            data={configurationSmtp}
            searchPlaceholder="Buscar configuración SMTP ..."
            pageSize={4}
            loading={loadingSmtp}
            emptyMessage="No hay registros"
            onRowClick={(data) => {}}
            showSearch={true}
            showPagination={true}
            onSearch={() => fetchSearchSmtp()}
            searchValue={searchValueSmtp}
            showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_CREATE)}
            setOpenModal={setOpenModalSmtp}
            setMode={setModeSmtp}
            setModel={setModelSmtp}
            setSearchValue={setSearchValueSmtp}
            onClear={() => onClearSmtp()}
            dataPagination={dataPaginationSmtp}
            setPageData={setPageDataSmtp}
            pageData={pageDataSmtp}
          />
        )}
        {activeTab === 'RENAPO' &&
          hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_RENAPO_READ) && (
            <ModalRenapoSystemConfigurations />
          )}

        {openModal && (
          <ModalColorsSystemConfigurations
            model={model}
            mode={mode}
            setOpen={setOpenModal}
            onClose={() => onCloseOpenModal()}
            onSaved={handleSaved}
            setEntities={setEntities}
            currentPrimaryColor={currentPrimaryColor}
            currentSecondaryColor={currentSecondaryColor}
          />
        )}
        {openModalSmtp && (
          <ModalSmtpSystemConfigurations
            mode={modeSmtp}
            model={modelSmtp}
            onClose={() => setOpenModalSmtp(false)}
            setEntities={setEntitiesSmtp}
          />
        )}
        {openModalConfirmation && (
          <ConfirmationMessage
            message={TOAST_INFO_IDS.ARE_YOU_SURE_WANT_TO_DELETE_THIS_RECORD}
            onConfirm={handleDelete}
            onCancel={() => {
              setOPenModalConfirmation(false);
            }}
          />
        )}
      </div>
    </DashboardLayout>
  );
}

export default SystemConfigurations;
